import { useState, useEffect } from 'react';
import { TopHoldings, GrowthRates, AssetAllocation } from 'src/Components/Organisms';
import {
    Size, 
    Regions, 
    MarketCap, 
    StockSector, 
    StyleBox, 
    MaturityDist, 
    CreditQuality, 
    FixedIncomeSector,
    AssetChart } from './index';
import moment from 'moment';

export default function Portfolio({portfolio}) {
    const [date, setDate] = useState(null);
    const [showDist, setShowDist] = useState(true);
    
    useEffect(() => {
        setDate(moment(portfolio.date, "YYYY-MM-DD").format("DD/MM/YYYY"));
    }, []);

    const showDistHandler = value => {
        setShowDist(value);
    }

    return <>
        <div className="ajb-grid-row">
            <div className="ajb-col-collapse">
                <div className="ajb-col-12 ajb-col-8-breakpoint">
                    <div className="card z-depth-0 margin-0">
                        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
                            <div className="ajb-grid-row">
                                <span className="card-title float-left float-none-sm" data-testid="assetAllocationHeader">Asset allocation %</span>
                                {date ? <p className="h7 float-right float-none-sm" data-testid="assetAllocationDate">{date}</p> : null}
                            </div>
                            <div className="ajb-grid-row margin-top-20">
                                <div className="ajb-col-collapse">

                                    <AssetChart 
                                        {...portfolio} />

                                    <div className="ajb-col-8 ajb-col-8-breakpoint margin-top-30-sm">
                                        <div className="card z-depth-0 margin-0">
                                            <div className="card-content padding-top-0 padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
                                                <AssetAllocation
                                                    {...portfolio}
                                                    page="assetAllocation" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div className="ajb-grid-row">
            <div className="ajb-col-collapse">
                <div className="ajb-col-12 ajb-col-8-breakpoint">
                    <div className="card z-depth-0 margin-0">
                        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
                            <div className="ajb-grid-row margin-top-20">
                                <div className="ajb-col-collapse">
                                        <StyleBox 
                                            type={1}
                                            {...portfolio.equityValuation} />
                                    <div className="ajb-col-4 ajb-col-8-breakpoint margin-top-30-sm">
                                        <Size
                                            {...portfolio} />
                                    </div>
                                    <div className="ajb-col-4 ajb-col-8-breakpoint margin-top-30-sm">
                                        <MarketCap
                                            formattedDate={date}
                                            {...portfolio} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <GrowthRates
            formattedDate={date}
            {...portfolio} />
        <Regions
            formattedDate={date}
            {...portfolio} />
        <StockSector
            formattedDate={date}
            {...portfolio} />
        
        {(portfolio.bondStatistics && portfolio.bondStatistics.styleBox) || showDist ? <div className="ajb-grid-row">
            {!(portfolio.bondStatistics && portfolio.bondStatistics.styleBox) ? <MaturityDist
                setShowDist={showDistHandler}
                formattedDate={date}
                {...portfolio} /> : <div className="ajb-col-collapse">
                    <div className="ajb-col-12 ajb-col-8-breakpoint">
                        <div className="card z-depth-0 margin-0">
                            <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
                                <div className="ajb-grid-row margin-top-20">
                                    <div className="ajb-col-collapse">
                                        <StyleBox 
                                            type={2}
                                            {...portfolio.bondStatistics} />
                                        <div className="ajb-col-8 ajb-col-8-breakpoint margin-top-30-sm">
                                            <MaturityDist
                                                setShowDist={showDistHandler}
                                                formattedDate={date}
                                                {...portfolio} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
        </div> : null}
        <CreditQuality
            formattedDate={date}
            {...portfolio} />
        <FixedIncomeSector
            formattedDate={date}
            {...portfolio} />
        <TopHoldings
            showTotals={true}
            {...portfolio} />
    </>
}